'use client';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '@workspace/ui/lib';
import { CircleIcon } from 'lucide-react';
import type * as React from 'react';

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('flex flex-col gap-3', className)}
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  readOnly = false,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  readOnly?: boolean;
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'border-input text-grey-700 dark:text-grey-200 focus-visible:border-ring aspect-square size-4 rounded-full border transition-[color,box-shadow] outline-none data-[state=checked]:text-pink-400 dark:data-[state=checked]:text-pink-400',
        props.disabled
          ? 'text-grey-200 dark:text-grey-800 hover:border-grey-200! dark:hover:border-grey-700! cursor-not-allowed'
          : 'dark:hover:bg-grey-900 hover:border-transparent hover:bg-pink-50 dark:hover:border-transparent',
        readOnly ? 'cursor-default' : 'cursor-pointer',

        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 fill-pink-400 data-[state=checked]:text-pink-400" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

export { RadioGroup, RadioGroupItem };
